<template>
  <div class="LocksAndPermissions">
    <div>
      <strong>تنظیمات قفل</strong>
      <v-divider class="my-2"></v-divider>
      <v-row>
        <v-col cols="6" sm="4" md="3" lg="2">آی پی سرور :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field hide-details solo dense v-model="config.LockServer"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">پورت سرور :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field hide-details solo dense v-model="config.LockPort"
        /></v-col>
      </v-row>

      <strong class="mt-3">برای ذخیره تغییرات رمز عبور را وارد نمایید.</strong>
      <v-divider class="my-2"></v-divider>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">رمز ورود پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field
            hide-details
            solo
            dense
            v-model="config.DBPassWord"
            :append-icon="showDBPassWord ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showDBPassWord ? 'text' : 'password'"
            @click:append="showDBPassWord = !showDBPassWord"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">رمز ورود مدیر :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field
            hide-details
            solo
            dense
            v-model="config.adminpass"
            :append-icon="showAdminPass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showAdminPass ? 'text' : 'password'"
            @click:append="showAdminPass = !showAdminPass"
        /></v-col>
      </v-row>

      <div class="d-flex">
        <v-spacer />
        <v-btn @click="btnConfigLock_click" color="primary"
          >بروز رسانی مشخصات قفل</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
export default {
  props: { config: Object },
  data() {
    return {
      txtLockServer: "",
      txtLockPort: "",
      txtDBPassWordLock: "",
      txtAdminPasswordLock: "",
      showDBPassWord: false,
      showAdminPass: false,
    };
  },
  methods: {
    btnConfigLock_click() {
      var saveConfigParams = this.config;
      this.$store
        .dispatch("saveConfig", { saveConfigParams })
        .then((result) => {
          ////console.log(result);
          if (result.type === ResultType.success && result.data) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("operationFailed"),
            });
          }
        });
    },
  },
};
</script>

<style>
</style>